<template>
    <div>
        <buttonlist
                @help="help"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>

        <el-tabs :tab-position="'top'" type="" v-model="editableTabsValue" style="margin-top: 0px" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[6593]')" name="0">
                    <div style="width: 50%;text-align: left;display: flex">
                    <el-link class="el-button--mini" type="primary" href="/excel/焊接人员占比.xls" download="焊接人员占比.xls">{{$t('getapi[6111]')}}</el-link>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
							accept=".xlsx"
                            :disabled="!btn.importhour"
                    >
                    <el-button slot="trigger" size="mini" type="primary" :disabled="!btn.importhour">{{$t('getapi[7136]')}}</el-button>
                    </el-upload>


                    <el-button type="primary"   style="margin-left: 8px" size="mini" :disabled="!btn.exphour"    @click="ExpWorkHour" >{{$t('getapi[7137]')}}</el-button>
                    <el-button type="primary" size="mini" :disabled="!btn.lookdetail"   @click="LookWorkHour" >{{$t('getapi[7138]')}}</el-button>
                    </div>
                    <el-table
                            id="xpane-0"
                    :data="dataSet"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight - reduceTableHeight"
                    :row-class-name="tableRowClassName"
                    @selection-change="handleSelectionChange"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
                            ref="singleTable"
                    >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_No" :label="$t('getapi[2095]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_Month" :label="$t('getapi[2088]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Work_Name" :label="$t('getapi[7139]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="User_Name" :label="$t('getapi[7140]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_00" :label="$t('getapi[7161]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_01" :label="$t('getapi[7141]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_02" :label="$t('getapi[7142]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_03" :label="$t('getapi[7143]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_04" :label="$t('getapi[7144]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_05" :label="$t('getapi[7145]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_06" :label="$t('getapi[7146]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_07" :label="$t('getapi[7147]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_08" :label="$t('getapi[7148]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_09" :label="$t('getapi[7149]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_10" :label="$t('getapi[7150]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_11" :label="$t('getapi[7151]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_12" :label="$t('getapi[7152]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_13" :label="$t('getapi[7153]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_14" :label="$t('getapi[7154]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_15" :label="$t('getapi[7155]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_16" :label="$t('getapi[7156]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_17" :label="$t('getapi[7157]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_18" :label="$t('getapi[7158]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_19" :label="$t('getapi[7159]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_20" :label="$t('getapi[7160]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[135]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[7162]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Modify_Time" :label="$t('getapi[7163]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Exclusively_id" :label="$t('getapi[111]')"></el-table-column>
                    </el-table>
                    <el-row class="page">
                    <el-col :span="18">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="100"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    ></el-pagination>
                    </el-col>
                    <el-col :span="6">
                    <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
                    </el-col>
                    </el-row>

                    </el-tab-pane>

                    <!-- #####################个人工时######################## -->
                    <el-tab-pane :label="$t('getapi[7165]')" name="1">
                        <el-button type="primary" size="mini"  @click="LookDetail" >{{$t('getapi[7164]')}}</el-button>
                    <el-table
                            id="xpane-1"
                    :data="dataSet1"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight - reduceTableHeight"
                    :row-class-name="tableRowClassName"
                    @selection-change="handleSelectionChange1"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
                            ref="singleTable1"
                    >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Relation_No" :label="$t('getapi[2095]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_Month" :label="$t('getapi[2088]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Work_Name" :label="$t('getapi[7139]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="User_Name" :label="$t('getapi[7166]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_Date" :label="$t('getapi[7167]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_00" :label="$t('getapi[7168]')" align="right"></el-table-column>

                    <el-table-column show-footer-overflow v-for="item in returnArrayB" 
					:key="item.ColumnsField"
					:label="item.ColumnsField"
					:prop="item.ColumnsName"
					align="right" 
					></el-table-column>

                    <el-table-column show-overflow-tooltip prop="Item_Remark" :label="$t('getapi[143]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[135]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Exclusively_id" :label="$t('getapi[111]')"></el-table-column>
                    </el-table>
                    <el-row class="page">
                    <el-col :span="18">
                    <el-pagination
                    @size-change="handleSizeChange1"
                    @current-change="handleCurrentChange1"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="100"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total1"
                    ></el-pagination>
                    </el-col>
                    <el-col :span="6">
                    <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
                    </el-col>
                    </el-row>

                    </el-tab-pane>
                     <!-- #####################个人明细######################## -->
                    <el-tab-pane :label="$t('getapi[7169]')" name="2">
                        <el-table
                                id="xpane-2"
                    :data="dataSet2"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight"
                    :row-class-name="tableRowClassName"
                    @selection-change="handleSelectionChange2"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
                                ref="singleTable2"
                    >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Relation_No" :label="$t('getapi[2095]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_Month" :label="$t('getapi[2088]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Work_Name" :label="$t('getapi[7139]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="User_Name" :label="$t('getapi[7166]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_Date" :label="$t('getapi[7167]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_00" :label="$t('getapi[7168]')" align="right"></el-table-column>
                    <el-table-column show-footer-overflow v-for="item in returnArrayC" 
					:key="item.ColumnsField"
					:label="item.ColumnsField"
					:prop="item.ColumnsName"
					align="right" 
					></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_Remark" :label="$t('getapi[143]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[135]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Exclusively_id" :label="$t('getapi[111]')"></el-table-column>
                    </el-table>
                    <el-row class="page">
                    <el-col :span="18">
                    <el-pagination
                    @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="100"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total2"
                    ></el-pagination>
                    </el-col>
                    <el-col :span="6">
                    <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
                    </el-col>
                    </el-row>

                    </el-tab-pane>
        </el-tabs>
        
        <serce :isVisible="isVisible" queryData="searchLib" ref="ser" @getser="serclick"></serce>

        <el-dialog v-dialogDrag :visible.sync="visReplacePart" :title="$t('getapi[6593]')" width="20%" :close-on-click-modal="false" >
            <div class="box" style="height: 120px;margin-top:5px">
            <div class="bbl">
            <span>工段</span>
            <el-select filterable popper-class="select-option" style="width: 200px;"
                        v-model="worknameselect"
                         size="mini">
                <el-option v-for="item in WorknameList" 
                           :key="item.Code"
                           :label="item.Name"
                           :value="item.Name"></el-option>
              </el-select>
            
            </div>
            <div class="bbl">
            <span>{{$t('getapi[1975]')}}</span>
            <el-date-picker
            v-model="monthselect"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM">
            </el-date-picker>
            
            </div>
            
             <div style="text-align:center;margin-top:20px">
                  <el-button type="primary" size="mini"  @click="confirmtrans">{{$t('getapi[1146]')}}</el-button>
            </div>

            </div>
            

        </el-dialog>
    </div>


</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'2_workhour',
        data() {
            return {
                editableTabsValue:'0',
                uploadurl:'',
                fileList:[],
                searchLib:'FrmWorkShopCost_Title',//0 FrmWorkShopCost_Title 1 FrmWorkShopCost_Total 2 FrmWorkShopCost_Line
                visReplacePart:false,
                dataSet: [], // 主表数据
                dataSet1:[],
                dataSet2:[],
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 100, // 当前页数据量
                pageIndex1: 1, // 当前页
                pageSize1: 100, // 当前页数据量
                pageIndex2: 1, // 当前页
                pageSize2: 100, // 当前页数据量
                SelectIndex: 0, //当前页面
                total: 0, // 数据总量
                total1:0,
                total2:0,
                loading: false, // 主表加载状态
                tableHeight: Common.tableHeight3, // 主表高度
                reduceTableHeight: Common.reduceTableHeight1,
                selectData: [],
                selectData1:[],
                DeptList:[],//领料部门数组
                transobj:{
                Qty: 0,
                cmbIssue_Dept: "",
                tempQty: 0,
                so_code: '',
                Flag: -1,
                Exclusively_ID: 0
                },
                btn:{
                    importhour:false,//导入工时
                    exphour:false,//导出工时
                    lookdetail:false,//查看项目工时
                    endIssue: false,
                    inStore:false,
                    delete: false,
                    transget:false,
                },
                returnArrayB:[],
                returnArrayC:[],
                WorknameList:[
                    {
                        Name:this.$t('getapi[8679]'),//'装配'
                        Code:'装配'

                    },
                    {
                        Name:this.$t('getapi[8676]'),//'焊接',
                        Code:'焊接'
                    }

                ],
                worknameselect:'装配',
                monthselect:new Date().getFullYear() + '-' + (new Date().getMonth()+1),
                filename:'',
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet1: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet2: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                }, 13)
            })
        },
        mounted: function() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            let token = JSON.parse(that.userData).token;
            let LangType=that.$processdata.getLang()
            that.uploadurl = Common.Url + '/Pro/Report/ImportFile?token=' + token+"&type=0&Order_Month="+that.monthselect+"&Work_Name="+that.worknameselect+"&file_src="+that.filename+"&LangType="+LangType;
            that.transobj.cmbIssue_Dept = that.DeptList[0].Name;            
            that.authority();
        },
        created: function(){
            this.DeptList = Array.methods.getIssueDeptList();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6593]"),this.$t("getapi[6589]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权                
                /*if (that.total > 0) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export,save,del');
                } else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,save,del');
                }*/
                if (that.$limits.authority('plv2', 494, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
                if (that.$limits.authority('plv2', 494, 1) == 2) {
                    if (that.$limits.authority('plv3', 494,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 494,1) == 1) {
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('save,search,refresh,export');
                    }
                    if (that.$limits.authority('plv3', 494, 1) == 2) {
                        //删除级
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export,save,del');
                    }
                }
                that.btnauthority();
            },
            btnauthority(){
                let that = this;
                if(that.$limits.authority('plv4', 495, 1) > 0){
                    that.btn.importhour = true;
                } else {
                    that.btn.importhour = false
                }
                if(that.selectData.length > 0){
                    that.btn.exphour = true;
                    that.btn.lookdetail = true;

                    that.btn.delete = true;
                    that.btn.transget = true;
                }else{
                    that.btn.exphour = false;
                    that.btn.lookdetail = false;

                    that.btn.delete = false;
                    that.btn.transget = false;
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.getView();
            },
            handleCurrentChange2(val) {
                this.pageIndex2 = val;
                this.getView();
            },
            handleChange(file, fileList) {
            let that = this;
            that.loading = true;
            console.log(file);
            if (file.response) {
            let response = file.response.Success;
            if (response == 0) {
            that.$message.error(file.response.Msg);
            } else {
            if(file.response.DataContent.dt.length>0){
            that.datajson = file.response.DataContent.dt;
            that.returnArray = file.response.DataContent.TbHeader;
            that.excelURL = file.response.DataContent.URL;
            }else{
            that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
            }
            }
            that.loading = false;
            }
            },
            handleSuccess(res, file, fileList) {
            let that = this;
            let response = res.Success;
            if (response == 0) {
            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
            } else {
                if(response==2){
                     that.visReplacePart = true;
                     that.worknameselect = res.UniqueNum;
                     that.filename = res.Key;
                     that.monthselect = new Date().getFullYear() + '-' + (new Date().getMonth());
                }

               

            }
            that.fileList=[];
            },
            handleError(err, file, fileList) {
            let that = this;
            that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },

            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, that.searchLib);
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.pageIndex = 1;
                this.pageIndex1 = 1;
                this.pageIndex2 = 1;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let token = JSON.parse(that.userData).token;
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Pro/Report/WorkShopCostList', data, function(res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        } else if (that.SelectIndex == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        } else if (that.SelectIndex == 2) {
                            that.dataSet2 = res.DataContent;
                            that.total2 = res.Totals;
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[6592]')
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pro/Report/WorkShopCostExportToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.queryData=[];
                if(that.SelectIndex==0){
                    that.searchLib = 'FrmWorkShopCost_Title';
                }else if(that.SelectIndex==1){
                     that.searchLib = 'FrmWorkShopCost_Total';
                }else {
                     that.searchLib = 'FrmWorkShopCost_Line';
                }
                //  1  2 

                that.getView();
                that.$nextTick(function(){
                    that.$processdata.initForm(that.SelectIndex)
                });
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = val;
                that.btnauthority();
            },
            handleSelectionChange1(val){
                let that = this;
                that.selectData1 = val;
                that.btnauthority();
            },
            tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
            },
            delline() {
            let that = this;

            let parm={
            ids:'',
            };
            for(let i=0;i<that.selectData.length;i++){
                parm.ids+=that.selectData[i].so_CODE+',';

            }
            parm.ids =  parm.ids.substring(0, parm.ids.length - 1);

            that.$http.urlpost('/Pro/MDIP/ProPartDelete', parm, function (res) {
            if (res.Success == 1) {
            that.$message.success(that.$t('getapi[659]'));//'删除成功'
            that.getView();
            } 
            });

            
            
            // for (let i = that.selectData.length - 1; i >= 0; i--) {
            // that.dataSet.splice(that.selectData[i].index, 1);
            // }



            },
            ExpWorkHour(){
                let that = this;
                if(that.selectData.length>1){
                    that.$message.warning(that.$t('getapi[8756]'));//"请选择一条数据！"
                    return;
                }
                let parm = {
                Order_Month:that.selectData[0].Order_Month,
                Work_Name: that.selectData[0].Work_Name,
                Order_No: that.selectData[0].Order_No
                }
                that.$http.urlpost('/Pro/Report/WorkShopCostLineExportToExecl', parm, function(res) {
                if (res.Success == 1) {
                let hrefurl = Common.Url + res.DataContent.URL;
                window.open(hrefurl);
                }
                });

            },
            //查看工时详细
            LookWorkHour(){
            let that = this;
            if(that.selectData.length>1){
                that.$message.warning(that.$t('getapi[8756]'));//"请选择一条数据！"
                return;
            }
            let param = {
                SelectIndex: 1,
                Relation_No: that.selectData[0].Order_No,
                Work_Name:that.selectData[0].Work_Name,
                User_Name: "",
                Order_Month: "",
            }
            that.$http.urlpost('/Pro/Report/WorkShopCostListBtnClick', param, function (res) {
            if (res.Success == 1) {
                that.dataSet1 = res.DataContent.Detail;
                that.returnArrayB=[];
                let retobj = res.DataContent.Remark[0];
                for(let i=1;i<=20;i++){
                    let columnName='';
                    if(i<=9){
                         columnName = 'Item_0'+i.toString();
                    }else{
                         columnName = 'Item_'+i.toString();
                    }
                    if(that.$limits.fnIsEmpty(retobj[columnName])){
                        break;
                    }
                    let oobj = {
                        ColumnsName:columnName,
                        ColumnsField:retobj[columnName]
                    }
                   that.returnArrayB.push(oobj);
                   
                }
                that.total1 = that.dataSet1.length;
                that.editableTabsValue='1';
            } 
            });



            },
            //查看个人明细
            LookDetail(){
            let that = this;
            if(that.selectData1.length>1){
                that.$message.warning(that.$t('getapi[8756]'));//"请选择一条数据！"
                return;
            }
            let param = {
                SelectIndex: 2,
                Relation_No: that.selectData1[0].Relation_No,
                Work_Name:that.selectData1[0].Work_Name,
                User_Name: that.selectData1[0].User_Name,
                Order_Month: ""
            }
            that.$http.urlpost('/Pro/Report/WorkShopCostListBtnClick', param, function (res) {
            if (res.Success == 1) {
                that.dataSet2 = res.DataContent.Detail;
                that.returnArrayC=[];
                let retobj = res.DataContent.Remark[0];
                for(let i=1;i<=20;i++){
                    let columnName='';
                    if(i<=9){
                        columnName = 'Item_0'+i.toString();
            }else{
                columnName = 'Item_'+i.toString();
            }
            if(that.$limits.fnIsEmpty(retobj[columnName])){
                break;
            }
            let oobj = {
                ColumnsName:columnName,
                ColumnsField:retobj[columnName]
            }
            that.returnArrayC.push(oobj);
            }
            that.total2 = that.dataSet2.length;
            that.editableTabsValue='2';
            } 
            });
            },
            showDialog(){
                let that = this;
                that.visReplacePart = true;
                that.transobj.Qty = that.selectData[0].pos_qty;
            },
            confirmtrans(){
                let that = this;
                let token = JSON.parse(that.userData).token;
                let LangType=that.$processdata.getLang()
                that.uploadurl = Common.Url + '/Pro/Report/ImportFile?token=' + token+"&type=1&Order_Month="+that.monthselect+"&Work_Name="+that.worknameselect+"&file_src="+that.filename+"&LangType="+LangType;
                that.$http.gets(that.uploadurl, '', function (res) {
                if (res.data.Success == 3) {
                    that.visReplacePart = false;
                    //新弹窗
                    //that.$processdata.explainCallbackMsg(res.Msg);
                    that.$confirm(res.data.Msg, that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        //再次请求
                        that.uploadurl = Common.Url + '/Pro/Report/ImportFile?token=' + token+"&type=2&Order_Month="+that.monthselect+"&Work_Name="+that.worknameselect+"&file_src="+that.filename+"&LangType="+LangType;
                        that.$http.gets(that.uploadurl, '', function (res) {
                            if(res.data.Success==1){
                                that.$message.success(that.$t('getapi[818]'));//'导入成功！'
                                that.getView();
                            }
                            else{
                                that.$message.error(that.$processdata.explainCallbackMsg(res.data.Msg));
                            }
                            that.loading = false;
                         });
                    })
                    .catch(() => {
                        that.loading = false;
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
                }
                else{
                    that.$message.error(that.$processdata.explainCallbackMsg(res.data.Msg));
                    that.loading = false;
                }
                });

            },
            endIssue(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        so_code: that.selectData[i].so_code,
                        part_id: that.selectData[i].part_id
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SO/SOMaterilEndIssue', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
span.title {
	width: 100%;
	display: flex;
	height: 40px;
	line-height: 40px;
}

span.title .el-switch {
	display: inline-block;
	margin: 8px 30px;
}
.box {
	width: 100%;
	overflow-x: auto;
	.bbl {
		margin: 0px auto 10px;
		white-space: pre;
		span {
			margin-left: 10px;
			min-width: 70px;
			text-align: left;
			line-height: 20px;
			display: inline-block;
			margin-right: 0px;
		}
    }
}
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
